/* tslint:disable */
/* eslint-disable */
/**
 * SFTP Permissioning API
 * Here You can find all the endpoints for the Permission API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { BulkDeleteAssignmentsAndProductsResponseDto } from '../models';
// @ts-ignore
import { BulkDeleteSummaryDto } from '../models';
// @ts-ignore
import { BusinessGroupEntity } from '../models';
// @ts-ignore
import { CascadeDeleteSummaryDto } from '../models';
// @ts-ignore
import { CreateBusinessGroupDto } from '../models';
// @ts-ignore
import { I18nErrorResponseDto } from '../models';
// @ts-ignore
import { PatchLoginAsAdminsDto } from '../models';
// @ts-ignore
import { UpdateBusinessGroupDto } from '../models';
/**
 * BusinessGroupsApi - axios parameter creator
 * @export
 */
export const BusinessGroupsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Deletes multiple assignments in a single operation. Returns summary of requested, successfully deleted, and failed assignment IDs.
         * @summary Bulk delete assignments by IDs
         * @param {string} ids Comma-separated Assignment IDs to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkDeleteAssignments: async (ids: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('bulkDeleteAssignments', 'ids', ids)
            const localVarPath = `/api/v1.0/business-groups/bulk-delete-assignments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", ["openid", "profile", "email", "offline_access", "groups"], configuration)

            if (ids !== undefined) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes multiple assignments and products in a single combined operation. Either parameter can be omitted if only one entity type needs deletion. Returns separate summaries for assignments and products.
         * @summary Bulk delete assignments and products by IDs
         * @param {any} [productIds] Comma-separated Product IDs to delete (optional)
         * @param {any} [assignmentIds] Comma-separated Assignment IDs to delete (optional)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkDeleteAssignmentsAndProducts: async (productIds?: any, assignmentIds?: any, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1.0/business-groups/bulk-delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", ["openid", "profile", "email", "offline_access", "groups"], configuration)

            if (productIds !== undefined) {
                localVarQueryParameter['productIds'] = productIds;
            }

            if (assignmentIds !== undefined) {
                localVarQueryParameter['assignmentIds'] = assignmentIds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes multiple products in a single operation. Returns summary of requested, successfully deleted, and failed product IDs.
         * @summary Bulk delete products by IDs
         * @param {string} ids Comma-separated Product IDs to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkDeleteProducts: async (ids: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('bulkDeleteProducts', 'ids', ids)
            const localVarPath = `/api/v1.0/business-groups/bulk-delete-products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", ["openid", "profile", "email", "offline_access", "groups"], configuration)

            if (ids !== undefined) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes specified Business Groups and cascades deletion to all dependent entities. The operation order is: 1) Remove BG references from Operator Users/Groups, 2) Delete associated Products, 3) Delete associated Assignments, 4) Remove assignment references from Users, 5) Delete Business Groups. Returns comprehensive summary including counts of updated Operator Users/Groups.
         * @summary Cascade delete business groups with all dependent entities
         * @param {string} ids Comma-separated Business Group IDs to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cascadeDeleteBusinessGroups: async (ids: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('cascadeDeleteBusinessGroups', 'ids', ids)
            const localVarPath = `/api/v1.0/business-groups/cascade-delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", ["openid", "profile", "email", "offline_access", "groups"], configuration)

            if (ids !== undefined) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a new business group
         * @param {CreateBusinessGroupDto} createBusinessGroupDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBusinessGroup: async (createBusinessGroupDto: CreateBusinessGroupDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createBusinessGroupDto' is not null or undefined
            assertParamExists('createBusinessGroup', 'createBusinessGroupDto', createBusinessGroupDto)
            const localVarPath = `/api/v1.0/business-groups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", ["openid", "profile", "email", "offline_access", "groups"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createBusinessGroupDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes the specified Business Group and, as side effects, deletes all its products & assignments and updates users to remove deleted assignment references.
         * @summary Delete a business group with cascade side effects
         * @param {string} id ID of the business group to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBusinessGroupCascade: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteBusinessGroupCascade', 'id', id)
            const localVarPath = `/api/v1.0/business-groups/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", ["openid", "profile", "email", "offline_access", "groups"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all business groups for the user or filters by id/name when query parameters are provided.
         * @summary List or search business groups
         * @param {any} [name] Name to search (optional, partial or exact match depending on backend logic)
         * @param {any} [id] Exact id to search (optional)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrSearchBusinessGroups: async (name?: any, id?: any, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1.0/business-groups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", ["openid", "profile", "email", "offline_access", "groups"], configuration)

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Patch loginAsAdmins for a business group
         * @param {string} businessGroupId ID of the business group
         * @param {PatchLoginAsAdminsDto} patchLoginAsAdminsDto Object containing addedLoginAsAdmin and/or removedLoginAsAdmin arrays of identifiers to patch loginAsAdmins for the business group
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchLoginAsAdminsForBusinessGroup: async (businessGroupId: string, patchLoginAsAdminsDto: PatchLoginAsAdminsDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessGroupId' is not null or undefined
            assertParamExists('patchLoginAsAdminsForBusinessGroup', 'businessGroupId', businessGroupId)
            // verify required parameter 'patchLoginAsAdminsDto' is not null or undefined
            assertParamExists('patchLoginAsAdminsForBusinessGroup', 'patchLoginAsAdminsDto', patchLoginAsAdminsDto)
            const localVarPath = `/api/v1.0/business-groups/{businessGroupId}/login-as-admins`
                .replace(`{${"businessGroupId"}}`, encodeURIComponent(String(businessGroupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", ["openid", "profile", "email", "offline_access", "groups"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchLoginAsAdminsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a business group
         * @param {string} id ID of the business group to update
         * @param {UpdateBusinessGroupDto} updateBusinessGroupDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBusinessGroup: async (id: string, updateBusinessGroupDto: UpdateBusinessGroupDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateBusinessGroup', 'id', id)
            // verify required parameter 'updateBusinessGroupDto' is not null or undefined
            assertParamExists('updateBusinessGroup', 'updateBusinessGroupDto', updateBusinessGroupDto)
            const localVarPath = `/api/v1.0/business-groups/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", ["openid", "profile", "email", "offline_access", "groups"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateBusinessGroupDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BusinessGroupsApi - functional programming interface
 * @export
 */
export const BusinessGroupsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BusinessGroupsApiAxiosParamCreator(configuration)
    return {
        /**
         * Deletes multiple assignments in a single operation. Returns summary of requested, successfully deleted, and failed assignment IDs.
         * @summary Bulk delete assignments by IDs
         * @param {string} ids Comma-separated Assignment IDs to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkDeleteAssignments(ids: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BulkDeleteSummaryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkDeleteAssignments(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Deletes multiple assignments and products in a single combined operation. Either parameter can be omitted if only one entity type needs deletion. Returns separate summaries for assignments and products.
         * @summary Bulk delete assignments and products by IDs
         * @param {any} [productIds] Comma-separated Product IDs to delete (optional)
         * @param {any} [assignmentIds] Comma-separated Assignment IDs to delete (optional)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkDeleteAssignmentsAndProducts(productIds?: any, assignmentIds?: any, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BulkDeleteAssignmentsAndProductsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkDeleteAssignmentsAndProducts(productIds, assignmentIds, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Deletes multiple products in a single operation. Returns summary of requested, successfully deleted, and failed product IDs.
         * @summary Bulk delete products by IDs
         * @param {string} ids Comma-separated Product IDs to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkDeleteProducts(ids: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BulkDeleteSummaryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkDeleteProducts(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Deletes specified Business Groups and cascades deletion to all dependent entities. The operation order is: 1) Remove BG references from Operator Users/Groups, 2) Delete associated Products, 3) Delete associated Assignments, 4) Remove assignment references from Users, 5) Delete Business Groups. Returns comprehensive summary including counts of updated Operator Users/Groups.
         * @summary Cascade delete business groups with all dependent entities
         * @param {string} ids Comma-separated Business Group IDs to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cascadeDeleteBusinessGroups(ids: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CascadeDeleteSummaryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cascadeDeleteBusinessGroups(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create a new business group
         * @param {CreateBusinessGroupDto} createBusinessGroupDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createBusinessGroup(createBusinessGroupDto: CreateBusinessGroupDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BusinessGroupEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createBusinessGroup(createBusinessGroupDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Deletes the specified Business Group and, as side effects, deletes all its products & assignments and updates users to remove deleted assignment references.
         * @summary Delete a business group with cascade side effects
         * @param {string} id ID of the business group to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteBusinessGroupCascade(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CascadeDeleteSummaryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteBusinessGroupCascade(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns all business groups for the user or filters by id/name when query parameters are provided.
         * @summary List or search business groups
         * @param {any} [name] Name to search (optional, partial or exact match depending on backend logic)
         * @param {any} [id] Exact id to search (optional)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrSearchBusinessGroups(name?: any, id?: any, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BusinessGroupEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrSearchBusinessGroups(name, id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Patch loginAsAdmins for a business group
         * @param {string} businessGroupId ID of the business group
         * @param {PatchLoginAsAdminsDto} patchLoginAsAdminsDto Object containing addedLoginAsAdmin and/or removedLoginAsAdmin arrays of identifiers to patch loginAsAdmins for the business group
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchLoginAsAdminsForBusinessGroup(businessGroupId: string, patchLoginAsAdminsDto: PatchLoginAsAdminsDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BusinessGroupEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchLoginAsAdminsForBusinessGroup(businessGroupId, patchLoginAsAdminsDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update a business group
         * @param {string} id ID of the business group to update
         * @param {UpdateBusinessGroupDto} updateBusinessGroupDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateBusinessGroup(id: string, updateBusinessGroupDto: UpdateBusinessGroupDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateBusinessGroup(id, updateBusinessGroupDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BusinessGroupsApi - factory interface
 * @export
 */
export const BusinessGroupsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BusinessGroupsApiFp(configuration)
    return {
        /**
         * Deletes multiple assignments in a single operation. Returns summary of requested, successfully deleted, and failed assignment IDs.
         * @summary Bulk delete assignments by IDs
         * @param {string} ids Comma-separated Assignment IDs to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkDeleteAssignments(ids: string, options?: any): AxiosPromise<BulkDeleteSummaryDto> {
            return localVarFp.bulkDeleteAssignments(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes multiple assignments and products in a single combined operation. Either parameter can be omitted if only one entity type needs deletion. Returns separate summaries for assignments and products.
         * @summary Bulk delete assignments and products by IDs
         * @param {any} [productIds] Comma-separated Product IDs to delete (optional)
         * @param {any} [assignmentIds] Comma-separated Assignment IDs to delete (optional)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkDeleteAssignmentsAndProducts(productIds?: any, assignmentIds?: any, options?: any): AxiosPromise<BulkDeleteAssignmentsAndProductsResponseDto> {
            return localVarFp.bulkDeleteAssignmentsAndProducts(productIds, assignmentIds, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes multiple products in a single operation. Returns summary of requested, successfully deleted, and failed product IDs.
         * @summary Bulk delete products by IDs
         * @param {string} ids Comma-separated Product IDs to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkDeleteProducts(ids: string, options?: any): AxiosPromise<BulkDeleteSummaryDto> {
            return localVarFp.bulkDeleteProducts(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes specified Business Groups and cascades deletion to all dependent entities. The operation order is: 1) Remove BG references from Operator Users/Groups, 2) Delete associated Products, 3) Delete associated Assignments, 4) Remove assignment references from Users, 5) Delete Business Groups. Returns comprehensive summary including counts of updated Operator Users/Groups.
         * @summary Cascade delete business groups with all dependent entities
         * @param {string} ids Comma-separated Business Group IDs to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cascadeDeleteBusinessGroups(ids: string, options?: any): AxiosPromise<CascadeDeleteSummaryDto> {
            return localVarFp.cascadeDeleteBusinessGroups(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a new business group
         * @param {CreateBusinessGroupDto} createBusinessGroupDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBusinessGroup(createBusinessGroupDto: CreateBusinessGroupDto, options?: any): AxiosPromise<BusinessGroupEntity> {
            return localVarFp.createBusinessGroup(createBusinessGroupDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes the specified Business Group and, as side effects, deletes all its products & assignments and updates users to remove deleted assignment references.
         * @summary Delete a business group with cascade side effects
         * @param {string} id ID of the business group to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBusinessGroupCascade(id: string, options?: any): AxiosPromise<CascadeDeleteSummaryDto> {
            return localVarFp.deleteBusinessGroupCascade(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all business groups for the user or filters by id/name when query parameters are provided.
         * @summary List or search business groups
         * @param {any} [name] Name to search (optional, partial or exact match depending on backend logic)
         * @param {any} [id] Exact id to search (optional)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrSearchBusinessGroups(name?: any, id?: any, options?: any): AxiosPromise<Array<BusinessGroupEntity>> {
            return localVarFp.getOrSearchBusinessGroups(name, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Patch loginAsAdmins for a business group
         * @param {string} businessGroupId ID of the business group
         * @param {PatchLoginAsAdminsDto} patchLoginAsAdminsDto Object containing addedLoginAsAdmin and/or removedLoginAsAdmin arrays of identifiers to patch loginAsAdmins for the business group
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchLoginAsAdminsForBusinessGroup(businessGroupId: string, patchLoginAsAdminsDto: PatchLoginAsAdminsDto, options?: any): AxiosPromise<BusinessGroupEntity> {
            return localVarFp.patchLoginAsAdminsForBusinessGroup(businessGroupId, patchLoginAsAdminsDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a business group
         * @param {string} id ID of the business group to update
         * @param {UpdateBusinessGroupDto} updateBusinessGroupDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBusinessGroup(id: string, updateBusinessGroupDto: UpdateBusinessGroupDto, options?: any): AxiosPromise<void> {
            return localVarFp.updateBusinessGroup(id, updateBusinessGroupDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for bulkDeleteAssignments operation in BusinessGroupsApi.
 * @export
 * @interface BusinessGroupsApiBulkDeleteAssignmentsRequest
 */
export interface BusinessGroupsApiBulkDeleteAssignmentsRequest {
    /**
     * Comma-separated Assignment IDs to delete
     * @type {string}
     * @memberof BusinessGroupsApiBulkDeleteAssignments
     */
    readonly ids: string
}

/**
 * Request parameters for bulkDeleteAssignmentsAndProducts operation in BusinessGroupsApi.
 * @export
 * @interface BusinessGroupsApiBulkDeleteAssignmentsAndProductsRequest
 */
export interface BusinessGroupsApiBulkDeleteAssignmentsAndProductsRequest {
    /**
     * Comma-separated Product IDs to delete (optional)
     * @type {any}
     * @memberof BusinessGroupsApiBulkDeleteAssignmentsAndProducts
     */
    readonly productIds?: any

    /**
     * Comma-separated Assignment IDs to delete (optional)
     * @type {any}
     * @memberof BusinessGroupsApiBulkDeleteAssignmentsAndProducts
     */
    readonly assignmentIds?: any
}

/**
 * Request parameters for bulkDeleteProducts operation in BusinessGroupsApi.
 * @export
 * @interface BusinessGroupsApiBulkDeleteProductsRequest
 */
export interface BusinessGroupsApiBulkDeleteProductsRequest {
    /**
     * Comma-separated Product IDs to delete
     * @type {string}
     * @memberof BusinessGroupsApiBulkDeleteProducts
     */
    readonly ids: string
}

/**
 * Request parameters for cascadeDeleteBusinessGroups operation in BusinessGroupsApi.
 * @export
 * @interface BusinessGroupsApiCascadeDeleteBusinessGroupsRequest
 */
export interface BusinessGroupsApiCascadeDeleteBusinessGroupsRequest {
    /**
     * Comma-separated Business Group IDs to delete
     * @type {string}
     * @memberof BusinessGroupsApiCascadeDeleteBusinessGroups
     */
    readonly ids: string
}

/**
 * Request parameters for createBusinessGroup operation in BusinessGroupsApi.
 * @export
 * @interface BusinessGroupsApiCreateBusinessGroupRequest
 */
export interface BusinessGroupsApiCreateBusinessGroupRequest {
    /**
     * 
     * @type {CreateBusinessGroupDto}
     * @memberof BusinessGroupsApiCreateBusinessGroup
     */
    readonly createBusinessGroupDto: CreateBusinessGroupDto
}

/**
 * Request parameters for deleteBusinessGroupCascade operation in BusinessGroupsApi.
 * @export
 * @interface BusinessGroupsApiDeleteBusinessGroupCascadeRequest
 */
export interface BusinessGroupsApiDeleteBusinessGroupCascadeRequest {
    /**
     * ID of the business group to delete
     * @type {string}
     * @memberof BusinessGroupsApiDeleteBusinessGroupCascade
     */
    readonly id: string
}

/**
 * Request parameters for getOrSearchBusinessGroups operation in BusinessGroupsApi.
 * @export
 * @interface BusinessGroupsApiGetOrSearchBusinessGroupsRequest
 */
export interface BusinessGroupsApiGetOrSearchBusinessGroupsRequest {
    /**
     * Name to search (optional, partial or exact match depending on backend logic)
     * @type {any}
     * @memberof BusinessGroupsApiGetOrSearchBusinessGroups
     */
    readonly name?: any

    /**
     * Exact id to search (optional)
     * @type {any}
     * @memberof BusinessGroupsApiGetOrSearchBusinessGroups
     */
    readonly id?: any
}

/**
 * Request parameters for patchLoginAsAdminsForBusinessGroup operation in BusinessGroupsApi.
 * @export
 * @interface BusinessGroupsApiPatchLoginAsAdminsForBusinessGroupRequest
 */
export interface BusinessGroupsApiPatchLoginAsAdminsForBusinessGroupRequest {
    /**
     * ID of the business group
     * @type {string}
     * @memberof BusinessGroupsApiPatchLoginAsAdminsForBusinessGroup
     */
    readonly businessGroupId: string

    /**
     * Object containing addedLoginAsAdmin and/or removedLoginAsAdmin arrays of identifiers to patch loginAsAdmins for the business group
     * @type {PatchLoginAsAdminsDto}
     * @memberof BusinessGroupsApiPatchLoginAsAdminsForBusinessGroup
     */
    readonly patchLoginAsAdminsDto: PatchLoginAsAdminsDto
}

/**
 * Request parameters for updateBusinessGroup operation in BusinessGroupsApi.
 * @export
 * @interface BusinessGroupsApiUpdateBusinessGroupRequest
 */
export interface BusinessGroupsApiUpdateBusinessGroupRequest {
    /**
     * ID of the business group to update
     * @type {string}
     * @memberof BusinessGroupsApiUpdateBusinessGroup
     */
    readonly id: string

    /**
     * 
     * @type {UpdateBusinessGroupDto}
     * @memberof BusinessGroupsApiUpdateBusinessGroup
     */
    readonly updateBusinessGroupDto: UpdateBusinessGroupDto
}

/**
 * BusinessGroupsApi - object-oriented interface
 * @export
 * @class BusinessGroupsApi
 * @extends {BaseAPI}
 */
export class BusinessGroupsApi extends BaseAPI {
    /**
     * Deletes multiple assignments in a single operation. Returns summary of requested, successfully deleted, and failed assignment IDs.
     * @summary Bulk delete assignments by IDs
     * @param {BusinessGroupsApiBulkDeleteAssignmentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessGroupsApi
     */
    public bulkDeleteAssignments(requestParameters: BusinessGroupsApiBulkDeleteAssignmentsRequest, options?: AxiosRequestConfig) {
        return BusinessGroupsApiFp(this.configuration).bulkDeleteAssignments(requestParameters.ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deletes multiple assignments and products in a single combined operation. Either parameter can be omitted if only one entity type needs deletion. Returns separate summaries for assignments and products.
     * @summary Bulk delete assignments and products by IDs
     * @param {BusinessGroupsApiBulkDeleteAssignmentsAndProductsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessGroupsApi
     */
    public bulkDeleteAssignmentsAndProducts(requestParameters: BusinessGroupsApiBulkDeleteAssignmentsAndProductsRequest = {}, options?: AxiosRequestConfig) {
        return BusinessGroupsApiFp(this.configuration).bulkDeleteAssignmentsAndProducts(requestParameters.productIds, requestParameters.assignmentIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deletes multiple products in a single operation. Returns summary of requested, successfully deleted, and failed product IDs.
     * @summary Bulk delete products by IDs
     * @param {BusinessGroupsApiBulkDeleteProductsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessGroupsApi
     */
    public bulkDeleteProducts(requestParameters: BusinessGroupsApiBulkDeleteProductsRequest, options?: AxiosRequestConfig) {
        return BusinessGroupsApiFp(this.configuration).bulkDeleteProducts(requestParameters.ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deletes specified Business Groups and cascades deletion to all dependent entities. The operation order is: 1) Remove BG references from Operator Users/Groups, 2) Delete associated Products, 3) Delete associated Assignments, 4) Remove assignment references from Users, 5) Delete Business Groups. Returns comprehensive summary including counts of updated Operator Users/Groups.
     * @summary Cascade delete business groups with all dependent entities
     * @param {BusinessGroupsApiCascadeDeleteBusinessGroupsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessGroupsApi
     */
    public cascadeDeleteBusinessGroups(requestParameters: BusinessGroupsApiCascadeDeleteBusinessGroupsRequest, options?: AxiosRequestConfig) {
        return BusinessGroupsApiFp(this.configuration).cascadeDeleteBusinessGroups(requestParameters.ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a new business group
     * @param {BusinessGroupsApiCreateBusinessGroupRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessGroupsApi
     */
    public createBusinessGroup(requestParameters: BusinessGroupsApiCreateBusinessGroupRequest, options?: AxiosRequestConfig) {
        return BusinessGroupsApiFp(this.configuration).createBusinessGroup(requestParameters.createBusinessGroupDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deletes the specified Business Group and, as side effects, deletes all its products & assignments and updates users to remove deleted assignment references.
     * @summary Delete a business group with cascade side effects
     * @param {BusinessGroupsApiDeleteBusinessGroupCascadeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessGroupsApi
     */
    public deleteBusinessGroupCascade(requestParameters: BusinessGroupsApiDeleteBusinessGroupCascadeRequest, options?: AxiosRequestConfig) {
        return BusinessGroupsApiFp(this.configuration).deleteBusinessGroupCascade(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns all business groups for the user or filters by id/name when query parameters are provided.
     * @summary List or search business groups
     * @param {BusinessGroupsApiGetOrSearchBusinessGroupsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessGroupsApi
     */
    public getOrSearchBusinessGroups(requestParameters: BusinessGroupsApiGetOrSearchBusinessGroupsRequest = {}, options?: AxiosRequestConfig) {
        return BusinessGroupsApiFp(this.configuration).getOrSearchBusinessGroups(requestParameters.name, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Patch loginAsAdmins for a business group
     * @param {BusinessGroupsApiPatchLoginAsAdminsForBusinessGroupRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessGroupsApi
     */
    public patchLoginAsAdminsForBusinessGroup(requestParameters: BusinessGroupsApiPatchLoginAsAdminsForBusinessGroupRequest, options?: AxiosRequestConfig) {
        return BusinessGroupsApiFp(this.configuration).patchLoginAsAdminsForBusinessGroup(requestParameters.businessGroupId, requestParameters.patchLoginAsAdminsDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a business group
     * @param {BusinessGroupsApiUpdateBusinessGroupRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessGroupsApi
     */
    public updateBusinessGroup(requestParameters: BusinessGroupsApiUpdateBusinessGroupRequest, options?: AxiosRequestConfig) {
        return BusinessGroupsApiFp(this.configuration).updateBusinessGroup(requestParameters.id, requestParameters.updateBusinessGroupDto, options).then((request) => request(this.axios, this.basePath));
    }
}
